import $ from 'jquery';
import closeAllMenus from '../core/INF-closeAllMenus';

const SiteOverlay = () => {
  $(document).on('click', '[data-site-overlay]', () => {
    closeAllMenus();
    $(document).trigger('scroll');
  });
};

export { SiteOverlay };